import { skills } from "./skillsData";

function SkillCard({ skill, index }) {
  const Icon = skill.icon;
  return (
    <div
      className="group relative flex flex-col items-center gap-4 p-6 rounded-2xl glass-morphism transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,200,200,0.4)] hover:border-cyan-400/50 hover:scale-110 hover:bg-white/15 cursor-pointer"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {/* Glow effect */}
      <div className="absolute -inset-1 bg-linear-to-r from-orange-400/20 to-cyan-400/20 rounded-2xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity -z-10"></div>

      <Icon
        className={`text-5xl ${skill.color} group-hover:scale-125 group-hover:drop-shadow-lg transition-transform duration-300`}
      />
      <span className="text-sm text-gray-400 group-hover:text-white transition-colors font-medium">
        {skill.name}
      </span>
    </div>
  );
}

function SkillGroup({ title, items }) {
  return (
    <div className="mb-24 animate-fade">
      <h3 className="text-center text-3xl font-bold text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text mb-12 tracking-wide uppercase">
        {title}
      </h3>

      <div className="flex flex-wrap justify-center gap-6 md:gap-8">
        {items.map((skill, index) => (
          <SkillCard key={index} skill={skill} index={index} />
        ))}
      </div>
    </div>
  );
}

export default function Skills() {
  return (
    <section
      id="skill"
      className="relative bg-[#0b0b0b] py-28 overflow-hidden text-white"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,180,80,0.1),transparent_60%)] animate-pulse" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(0,200,200,0.08),transparent_70%)]" />

      {/* Floating elements */}
      <div className="absolute top-1/4 left-10 w-64 h-64 bg-orange-400/10 rounded-full blur-3xl animate-float opacity-20" />
      <div
        className="absolute bottom-1/3 right-10 w-72 h-72 bg-cyan-400/10 rounded-full blur-3xl animate-float opacity-20"
        style={{ animationDelay: "1.5s" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <h2 className="text-center text-6xl font-bold mb-24 tracking-wide">
          <span className="text-gray-300">My</span>{" "}
          <span className="text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
            Skills
          </span>
        </h2>

        <SkillGroup title="Backend" items={skills.backend} />
        <SkillGroup title="Frontend (Web)" items={skills.frontend} />
        <SkillGroup title="Design & Graphics" items={skills.design} />
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-linear-to-t from-black to-transparent" />
    </section>
  );
}
